import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/navigation.css';
import { useLanguage } from "../common/LanguageContext";

function NavLinks({ direction = 'row', onLinkClick  }) {
  const { translations } = useLanguage();


  const links = [
    { name: translations.menuText.links.collection, path: '/collection' },
    { name: translations.menuText.links.gallery, path: '/gallery' },
    { name: translations.menuText.links.constructor, path: '/constructor' },
    { name: translations.menuText.links.designer, path: '/designers' }, // Ссылка на страницу "Дизайнерам"
    { name: translations.menuText.links.info, path: '/info' },
  ];


  return (
    <nav 
      className="nav-links" 
      style={{ flexDirection: direction }} // Меняем направление с помощью стилей
    >
      {links.map((link) => (
        <Link
          key={link.name}
          to={link.path}
          className="nav-link"
          onClick={onLinkClick} // Закрываем меню при клике
        >
          {link.name}
        </Link>
      ))}
    </nav>
  );
}

export default NavLinks;
